import { useState } from "react";
import { useNavigate, Link } from "react-router-dom";
import { toast } from "sonner";
import { Loader2 } from "lucide-react";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import { useAuth, dashboardPath } from "@/context/AuthContext";
import { Logo } from "@/components/Navbar";
import { apiError } from "@/lib/api";

export default function Login() {
  const { login } = useAuth();
  const navigate = useNavigate();
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [loading, setLoading] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    setLoading(true);
    try {
      const u = await login(email, password);
      toast.success("Accesso effettuato");
      navigate(dashboardPath(u.role));
    } catch (err) {
      toast.error(apiError(err.response?.data?.detail));
    } finally { setLoading(false); }
  };

  const googleLogin = () => {
    // REMINDER: DO NOT HARDCODE THE URL, OR ADD ANY FALLBACKS OR REDIRECT URLS, THIS BREAKS THE AUTH
    const redirectUrl = window.location.origin + "/dashboard/bnb";
    window.location.href = `https://auth.emergentagent.com/?redirect=${encodeURIComponent(redirectUrl)}`;
  };

  return (
    <div className="min-h-screen grid lg:grid-cols-2">
      <div className="hidden lg:flex flex-col justify-between bg-navy text-white p-12">
        <Link to="/" className="text-2xl font-heading font-extrabold">Morning<span className="text-orange">Box</span></Link>
        <div>
          <h1 className="text-4xl font-extrabold leading-tight">La colazione perfetta,<br /><span className="text-orange">dove vuoi tu.</span></h1>
          <p className="mt-4 text-white/60 max-w-md">Accedi alla tua area partner per gestire ordini, pacchetti e QR code.</p>
        </div>
        <p className="text-white/40 text-sm">© {new Date().getFullYear()} MorningBox</p>
      </div>
      <div className="flex items-center justify-center p-6 bg-cream">
        <div className="w-full max-w-md bg-white rounded-3xl brand-shadow p-8">
          <div className="lg:hidden mb-6"><Logo /></div>
          <h2 className="text-2xl font-bold text-navy">Accedi</h2>
          <p className="text-navy/50 text-sm mt-1">Area partner e amministratore</p>
          <form onSubmit={submit} className="mt-6 space-y-4">
            <div><Label>Email</Label><Input required type="email" value={email} onChange={(e) => setEmail(e.target.value)} className="rounded-xl mt-1 h-11" data-testid="login-email" /></div>
            <div><Label>Password</Label><Input required type="password" value={password} onChange={(e) => setPassword(e.target.value)} className="rounded-xl mt-1 h-11" data-testid="login-password" /></div>
            <Button type="submit" disabled={loading} className="w-full rounded-full bg-navy text-white h-11" data-testid="login-submit">
              {loading ? <Loader2 className="w-4 h-4 animate-spin" /> : "Accedi"}
            </Button>
          </form>
          <div className="flex items-center gap-3 my-5"><div className="flex-1 h-px bg-navy/10" /><span className="text-xs text-navy/40">oppure</span><div className="flex-1 h-px bg-navy/10" /></div>
          <Button onClick={googleLogin} variant="outline" className="w-full rounded-full h-11 border-navy/20" data-testid="login-google">
            <img src="https://www.gstatic.com/firebasejs/ui/2.0.0/images/auth/google.svg" alt="" className="w-5 h-5 mr-2" /> Accedi con Google
          </Button>
          <p className="mt-6 text-center text-sm text-navy/60">
            Non hai un account?{" "}
            <Link to="/diventa-partner" className="text-orange font-medium">Diventa partner</Link>
          </p>
        </div>
      </div>
    </div>
  );
}
